<template>
  <div
    v-if="hasGlobal"
    v-tooltip="{ text: tooltip }"
    class="pb-item-icon pb-item-template-icon"
  >
    <UiIcon
      icon="link"
      :color="hasLocalChanges ? 'info' : 'muted'"
    />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import vTooltip from '@nicolaudie-group/ng-ui-kit/directives/vTooltip'
import UiIcon from '@nicolaudie-group/ng-ui-kit/components/UiIcon/UiIcon.vue'
import useTranslate from '@/composables/useTranslate'

const props = defineProps({
  hasGlobal: { type: Boolean, default: false },
  hasLocalChanges: { type: Boolean, default: false },
})

const { translate } = useTranslate()

const tooltip = computed(() => (
  props.hasLocalChanges
    ? translate('pb2.templateLinkIcon.changedFromTemplate')
    : translate('pb2.templateLinkIcon.linkedToTemplate')
))
</script>

<style lang="scss" src="./ItemIcon.scss" />
